module.exports = __webpack_public_path__ + "img/foreplay-icon.aac67d8c.png";